export interface CatMeme {
  id: number;
  title: string;
  image: string;
  category: string;
  tags: string[];
  likes: number;
  shares: number;
  week: string;
  isHot: boolean;
  isFeatured: boolean;
  caption: string;
}

export const catMemes: CatMeme[] = [
  {
    id: 1,
    title: "Monday Morning Mood",
    image: "https://public.readdy.ai/ai/img_res/291c103e283b9b762f5d0ca57769e06c.jpg",
    category: "Relatable",
    tags: ["monday", "mood", "coffee", "relatable"],
    likes: 24800,
    shares: 8300,
    week: "This Week",
    isHot: true,
    isFeatured: true,
    caption: "Me every Monday before my first coffee ☕😾"
  },
  {
    id: 2,
    title: "Zoom Meeting Photobomb",
    image: "https://readdy.ai/api/search-image?query=fluffy%20white%20cat%20walking%20across%20a%20laptop%20keyboard%20during%20a%20video%20call%2C%20funny%20expression%2C%20home%20office%20setting%2C%20bright%20natural%20light%2C%20cute%20and%20chaotic%20scene%2C%20photorealistic%20cat%20photo%2C%20high%20quality&width=600&height=600&seq=meme002&orientation=squarish",
    category: "Work From Home",
    tags: ["zoom", "wfh", "photobomb", "laptop"],
    likes: 31200,
    shares: 12400,
    week: "This Week",
    isHot: true,
    isFeatured: false,
    caption: "My coworker just joined the meeting uninvited... again 💻😂"
  },
  {
    id: 3,
    title: "The Loaf Position",
    image: "https://readdy.ai/api/search-image?query=grey%20cat%20sitting%20in%20perfect%20loaf%20position%20with%20paws%20tucked%20under%20body%2C%20smug%20expression%2C%20clean%20white%20background%2C%20studio%20lighting%2C%20funny%20cat%20pose%2C%20photorealistic%20high%20quality%20cat%20photo&width=600&height=600&seq=meme003&orientation=squarish",
    category: "Classic",
    tags: ["loaf", "classic", "pose", "smug"],
    likes: 19500,
    shares: 6700,
    week: "This Week",
    isHot: false,
    isFeatured: false,
    caption: "Activating maximum loaf mode. Do not disturb. 🍞"
  },
  {
    id: 4,
    title: "3AM Zoomies",
    image: "https://readdy.ai/api/search-image?query=black%20cat%20with%20wide%20crazy%20eyes%20running%20at%20full%20speed%20through%20a%20dark%20hallway%20at%20night%2C%20motion%20blur%2C%20chaotic%20energy%2C%20funny%20cat%20expression%2C%20dramatic%20lighting%2C%20photorealistic%20cat%20action%20shot&width=600&height=600&seq=meme004&orientation=squarish",
    category: "Chaos",
    tags: ["zoomies", "3am", "chaos", "night"],
    likes: 42100,
    shares: 18900,
    week: "This Week",
    isHot: true,
    isFeatured: false,
    caption: "It is 3AM. The demons have arrived. 👁️👁️"
  },
  {
    id: 5,
    title: "Judging You Silently",
    image: "https://readdy.ai/api/search-image?query=elegant%20siamese%20cat%20sitting%20upright%20with%20a%20deeply%20judgmental%20and%20disapproving%20expression%2C%20looking%20down%20at%20camera%2C%20regal%20pose%2C%20soft%20neutral%20background%2C%20photorealistic%20cat%20portrait%2C%20high%20detail&width=600&height=600&seq=meme005&orientation=squarish",
    category: "Judgy",
    tags: ["judging", "siamese", "regal", "disapproval"],
    likes: 28700,
    shares: 9100,
    week: "This Week",
    isHot: false,
    isFeatured: false,
    caption: "I have seen your browser history. I am disappointed. 😒"
  },
  {
    id: 6,
    title: "Box Obsession",
    image: "https://readdy.ai/api/search-image?query=chubby%20tabby%20cat%20squeezed%20into%20a%20tiny%20cardboard%20box%20that%20is%20way%20too%20small%2C%20looking%20very%20pleased%20with%20itself%2C%20funny%20and%20cute%2C%20bright%20living%20room%20background%2C%20photorealistic%20cat%20photo%2C%20high%20quality&width=600&height=600&seq=meme006&orientation=squarish",
    category: "Classic",
    tags: ["box", "classic", "chubby", "satisfied"],
    likes: 35600,
    shares: 14200,
    week: "Last Week",
    isHot: false,
    isFeatured: false,
    caption: "If I fits, I sits. This is law. 📦"
  },
  {
    id: 7,
    title: "The Void Stare",
    image: "https://readdy.ai/api/search-image?query=all%20black%20cat%20staring%20intensely%20at%20a%20blank%20wall%20in%20a%20dark%20room%2C%20mysterious%20and%20eerie%20atmosphere%2C%20only%20the%20cats%20glowing%20eyes%20visible%2C%20dramatic%20shadow%20lighting%2C%20photorealistic%20cat%20photo%2C%20cinematic%20quality&width=600&height=600&seq=meme007&orientation=squarish",
    category: "Spooky",
    tags: ["void", "stare", "spooky", "mysterious"],
    likes: 22300,
    shares: 7800,
    week: "Last Week",
    isHot: false,
    isFeatured: false,
    caption: "He sees things we cannot see. He knows things we cannot know. 🌑"
  },
  {
    id: 8,
    title: "Dinner Time Alarm",
    image: "https://readdy.ai/api/search-image?query=hungry%20orange%20cat%20with%20huge%20wide%20open%20mouth%20meowing%20loudly%20directly%20at%20camera%2C%20demanding%20food%2C%20kitchen%20background%2C%20funny%20and%20dramatic%20expression%2C%20photorealistic%20cat%20photo%2C%20high%20quality%20detail&width=600&height=600&seq=meme008&orientation=squarish",
    category: "Relatable",
    tags: ["hungry", "dinner", "loud", "demanding"],
    likes: 39400,
    shares: 16500,
    week: "Last Week",
    isHot: true,
    isFeatured: false,
    caption: "IT IS 4:58PM. MY DINNER IS AT 5PM. I WILL NOT WAIT. 🍽️😤"
  },
  {
    id: 9,
    title: "Laptop Warmth Seeker",
    image: "https://readdy.ai/api/search-image?query=fluffy%20cat%20lying%20directly%20on%20top%20of%20an%20open%20laptop%20computer%2C%20completely%20blocking%20the%20screen%2C%20looking%20very%20comfortable%20and%20content%2C%20home%20office%20setting%2C%20warm%20lighting%2C%20photorealistic%20cat%20photo&width=600&height=600&seq=meme009&orientation=squarish",
    category: "Work From Home",
    tags: ["laptop", "warm", "wfh", "blocking"],
    likes: 27100,
    shares: 10300,
    week: "Last Week",
    isHot: false,
    isFeatured: false,
    caption: "Your deadline is not my problem. This laptop is warm. 💻🔥"
  },
  {
    id: 10,
    title: "The Slow Blink",
    image: "https://readdy.ai/api/search-image?query=beautiful%20fluffy%20maine%20coon%20cat%20doing%20a%20slow%20blink%20with%20half-closed%20eyes%2C%20serene%20and%20loving%20expression%2C%20soft%20bokeh%20background%2C%20warm%20golden%20light%2C%20photorealistic%20cat%20portrait%2C%20ultra%20high%20quality&width=600&height=600&seq=meme010&orientation=squarish",
    category: "Wholesome",
    tags: ["slowblink", "love", "wholesome", "maincoon"],
    likes: 51200,
    shares: 22700,
    week: "Last Week",
    isHot: true,
    isFeatured: true,
    caption: "This is a cat kiss. You have been blessed. Pass it on. 😻"
  },
  {
    id: 11,
    title: "Grocery Bag Inspector",
    image: "https://readdy.ai/api/search-image?query=curious%20tabby%20cat%20with%20head%20deep%20inside%20a%20paper%20grocery%20bag%2C%20investigating%20the%20contents%2C%20funny%20pose%20with%20tail%20sticking%20out%2C%20kitchen%20floor%20setting%2C%20photorealistic%20cat%20photo%2C%20high%20quality&width=600&height=600&seq=meme011&orientation=squarish",
    category: "Chaos",
    tags: ["grocery", "curious", "inspector", "bag"],
    likes: 18900,
    shares: 5400,
    week: "2 Weeks Ago",
    isHot: false,
    isFeatured: false,
    caption: "I must inspect every item before it enters this household. 🛍️🔍"
  },
  {
    id: 12,
    title: "Sunbeam Nap Expert",
    image: "https://readdy.ai/api/search-image?query=golden%20tabby%20cat%20stretched%20out%20luxuriously%20in%20a%20perfect%20sunbeam%20on%20hardwood%20floor%2C%20completely%20relaxed%20and%20blissful%2C%20warm%20golden%20afternoon%20light%2C%20peaceful%20home%20setting%2C%20photorealistic%20cat%20photo%2C%20high%20quality&width=600&height=600&seq=meme012&orientation=squarish",
    category: "Wholesome",
    tags: ["sunbeam", "nap", "relax", "golden"],
    likes: 44700,
    shares: 19800,
    week: "2 Weeks Ago",
    isHot: false,
    isFeatured: false,
    caption: "Found the one perfect sunbeam. Life is complete. ☀️😌"
  },
];

export const memeCategories = [
  { id: 'all', name: 'All Memes', icon: 'ri-image-2-line' },
  { id: 'Relatable', name: 'Relatable', icon: 'ri-emotion-laugh-line' },
  { id: 'Work From Home', name: 'WFH Life', icon: 'ri-computer-line' },
  { id: 'Classic', name: 'Classics', icon: 'ri-star-line' },
  { id: 'Chaos', name: 'Chaos Mode', icon: 'ri-fire-line' },
  { id: 'Judgy', name: 'Judgy Cats', icon: 'ri-eye-line' },
  { id: 'Wholesome', name: 'Wholesome', icon: 'ri-heart-line' },
  { id: 'Spooky', name: 'Spooky', icon: 'ri-ghost-line' },
];
